import React, { useState } from "react";
import { LaundryViewReceipt } from "../components/HeaderAttribute";
import GridPage from "../components/GridPage";

const LaundryReceiptViewPopup = ({ data, data1 }) => {


    return (
        <div class="w-full p-5">
            <div class=" border-black  "></div>
            <GridPage
                title={`Receipts > ${data.ReceiptNo} > ${data.FormatedDate}`}
                header={LaundryViewReceipt}
                records={data1}
                addView={true}
                tableHeight="h-60 overflow-y-auto"
            />
        </div>
    );
};

export default LaundryReceiptViewPopup;
